import React, { Component } from "react";
import ReactGiphySearchbox from "react-giphy-searchbox";
import projectSettings from "../../assets/Js/projectSettings";
import gifTypes from "../../assets/Js/gifTypes";

export default function GifsandStickers({ whichType, handleSelection }) {
  const windowWidth = window.innerWidth;

  return (
    <>
      {whichType === gifTypes.gif && (
        <div className="ml-2 mt-3">
          <ReactGiphySearchbox
            apiKey={projectSettings.giphyApiKey}
            gifPerPage={30}
            onSelect={(item) => {
              console.log("Selected Gif", item);
              handleSelection(item);
            }}
            masonryConfig={[
              {
                columns: 2,
                imageWidth: (windowWidth / 100) * 1.7 + 100,
                gutter: 5,
              },
              {
                mq: "700px",
                columns: Math.floor(windowWidth / 180 + 2),
                imageWidth: (windowWidth / 100) * 1.7 + 100,
                gutter: 5,
              },
            ]}
          />
        </div>
      )}
      {whichType === gifTypes.sticker && (
        <div className="ml-2 mt-3">
          <ReactGiphySearchbox
            apiKey={projectSettings.giphyApiKey}
            library="stickers"
            onSelect={(item) => {
              console.log("Selected Gif", item);
              handleSelection(item);
            }}
            masonryConfig={[
              {
                columns: 2,
                imageWidth: (windowWidth / 100) * 1.7 + 100,
                gutter: 5,
              },
              {
                mq: "700px",
                columns: Math.floor(windowWidth / 180 + 2),
                imageWidth: (windowWidth / 100) * 1.7 + 100,
                gutter: 5,
              },
            ]}
          />
        </div>
      )}
    </>
  );
}
